import React, { FC } from "react";
import { useStyles } from "./Header.style";
import { Typography, TypographyVariant } from "../Typography/Typography";

interface IHeaderProps {
  rightElement?: React.ReactNode;
  title?: string | React.ReactNode;
  leftElement?: React.ReactNode;
}

export const Header: FC<IHeaderProps> = ({
  rightElement,
  title,
  leftElement,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <div className={classes.leftElement}>{leftElement}</div>
      {typeof title === "string" ? (
        <Typography
          variant={TypographyVariant.BodyB4Bold}
          className={classes.title}
        >
          {title}
        </Typography>
      ) : (
        title
      )}
      <div className={classes.rightElement}>{rightElement}</div>
    </div>
  );
};
